export { useAttachments } from './useAttachments';
export { useWatermarkedCourseAttachment } from './useWatermarkedCourseAttachment';
